import UpcomingMeetingUseCase from "@domains/salesFeatures/Homepage/useCases/upcomingMeetingsUseCase";
import UpcomingEventUseCase from "@domains/salesFeatures/Homepage/useCases/UpcomingEventsUseCase";
import ExpiringLeadUseCase from "@domains/salesFeatures/Homepage/useCases/expiringLeadsUsecase";
import EngagementDashboardUseCase from "@domains/salesFeatures/Homepage/useCases/engagementDashboard";
import EngagementDashboardStatusUseCase from "@domains/salesFeatures/Homepage/useCases/engagementDashboardStatusUC";
import DownloadLeadsDataUseCase from "@domains/salesFeatures/Homepage/useCases/DownloadLeadsDataUseCase";
import DownloadEngagementDataUseCase from "@domains/salesFeatures/Homepage/useCases/DownloadEngagementDataUseCase";
import DownloadNRDataUseCase from "@domains/salesFeatures/Homepage/useCases/DownloadNRDataUseCase";
export default (function (repo) {
    return {
        eventActivities: {
            upcomingMeetings: new UpcomingMeetingUseCase(repo.eventActivities.upcomingMeetings),
            upcomingEvents: new UpcomingEventUseCase(repo.eventActivities.upcomingEvents),
            expiringLeads: new ExpiringLeadUseCase(repo.eventActivities.expiringLeads),
        },
        engagementDashboard: new EngagementDashboardUseCase(repo.engagementDashboard),
        engagementDashboardStatus: new EngagementDashboardStatusUseCase(repo.engagementDashboardStatus),
        downloadLeadsData: new DownloadLeadsDataUseCase(repo.downloadHomeData),
        downloadEngagementData: new DownloadEngagementDataUseCase(repo.downloadHomeData),
        downloadNRData: new DownloadNRDataUseCase(repo.downloadHomeData),
    };
});
